import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideTransloco } from '@ngneat/transloco';
import { environment } from '../environments/environments';
import { TranslocoHttpLoader } from './transloco-loader';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { loadingInterceptor } from './core/interceptors/loading.interceptor.service';
import { httpErrorInterceptor } from './core/interceptors/http-error-interceptor.service';
import { authInterceptor } from './core/interceptors/auth-interceptor.service';
import { MessageService } from 'primeng/api';
import { ToastService } from './core/services/toast/toast.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([
        loadingInterceptor,
        httpErrorInterceptor,
        authInterceptor
      ])),
    provideTransloco({
      config: {
        availableLangs: ['pt-br', 'es'],
        defaultLang: 'es',
        fallbackLang: 'pt-br',
        reRenderOnLangChange: true,
        prodMode: environment.production,
        missingHandler: {
          logMissingKey: true
        }
      },
      loader: TranslocoHttpLoader,
    }),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: { darkModeSelector: '.dark' }
      }
    }),
    MessageService,
    ToastService
  ]
};
